import { Component, ViewEncapsulation, AfterViewChecked, Renderer2, ElementRef } from '@angular/core';
import { MenuService } from './menu.service';
import { ConfigService } from 'src/app/service/config.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  providers: [MenuService],
  styleUrls: ['./side-menu.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SideMenuComponent implements AfterViewChecked {
  public items: any[];
  public css: string;
  public projectColor: string;

  constructor( menuService: MenuService, private renderer: Renderer2, private elRef: ElementRef, private config: ConfigService) {
    this.css = config.values.projectCSS;
    this.projectColor = config.values.projectColor;
    this.items = menuService.getFiles();
   }

  // convert the received data to menu items.
  private mapItems(items: any[], textFields: string[], childFields: string[], level: number = 0): any[] {
    const childField = childFields[level];
    const textField = textFields[level];

    return items.map(item => {
      const result: any = {
        text: item[textField]
      };
      // convert the children data to menu items.
      if (childField && item[childField]) {
        result.items = this.mapItems(item[childField], textFields, childFields, level + 1);
      }
      //document.querySelector("body").style.cssText = "--my-var: " + this.projectColor;
      return result;
    });
  }

  public iconClass({ text, items, iconClass, path }: any): any {
    let icon = 'k-icon ';
    if (items !== undefined){
      icon += 'k-i-folder';
    }
    else if (iconClass !== undefined){
      icon += iconClass;
    }

    return icon;
  }

  ngAfterViewChecked() {
    this.renderer.setStyle(this.elRef.nativeElement.querySelector('.sidenav ul.k-widget.k-reset.k-menu'), 'background-color', this.projectColor);
  }

}
